import { defineComponent as _defineComponent } from 'vue'
import { NeoButton } from '@kodadot1/brick'
import { ComputedRef } from '@nuxt/bridge/dist/runtime/composables'
import { Chain } from '@/utils/teleport'

type Tab = {
  label: string
  value: Chain
  disabled?: ComputedRef<boolean>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TeleportTabs',
  props: {
    tabs: null,
    value: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {




return { __sfc: true,emit, NeoButton }
}

})